import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { DashboardCardProps } from '@/types/photographer';

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  change,
  icon: Icon,
  className = '',
}) => {
  const formatValue = (val: string | number): string => {
    if (typeof val === 'number') {
      if (title.toLowerCase().includes('revenue') || title.toLowerCase().includes('$')) {
        return `$${val.toLocaleString()}`;
      }
      return val.toLocaleString();
    }
    return val;
  };

  const getTrendIcon = (trend: 'up' | 'down' | 'neutral') => {
    switch (trend) {
      case 'up':
        return <TrendingUp className="h-4 w-4 text-green-500" />;
      case 'down':
        return <TrendingDown className="h-4 w-4 text-red-500" />;
      default:
        return <Minus className="h-4 w-4 text-gray-400" />;
    }
  };

  const getTrendColor = (trend: 'up' | 'down' | 'neutral') => {
    switch (trend) {
      case 'up':
        return 'text-green-600';
      case 'down':
        return 'text-red-600';
      default:
        return 'text-gray-500';
    }
  };

  return (
    <div className={`bg-white overflow-hidden shadow rounded-lg ${className}`}>
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">{Icon && <Icon className="h-6 w-6 text-gray-400" />}</div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">{title}</dt>
              <dd className="text-2xl font-semibold text-gray-900">{formatValue(value)}</dd>
            </dl>
          </div>
        </div>

        {change && (
          <div className="mt-4 flex items-center">
            <div className="flex items-center">
              {getTrendIcon(change.trend)}
              <span className={`ml-1 text-sm font-medium ${getTrendColor(change.trend)}`}>
                {Math.abs(change.value)}%
              </span>
            </div>
            <span className="ml-2 text-sm text-gray-500">vs {change.period}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardCard;
